import "../Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import Loader from "components/loader";



const fileTypes = ["JPG", "PNG", "WEBP","JPEG"];
const MAX_SIZE = 10 * 1024 * 1024; // 10MB


const EditChallenge = () => {
    const [img, setImg] = useState(null);
    const [cover, setCover] = useState(null);
    const [cardLoading, setCardLoading] = useState(false);
    const [coverLoading, setCoverLoading] = useState(false);
    
    const { id } = useParams();
    const navigate = useNavigate();
  console.log("challengeId:", id);
        const [formInputs , setFormInputs] = useState({
          title:"",
          subject:"",
          grade:"",
          challengeTheme:"",
          designSubmission:"",
          nutshell:"",
          mission:"",
          judgingCriteria:"",
          termsConditions:"",
          videoUrl:"",
        });
    
      const success = () => {
           message.success('Your Challenge Edited successfully');
          };
    const successPhoto = () => {
           message.success('Your Image uploaded successfully');
          };
          const errormassage = (massage) => {
               message.error(massage);
              }
      const sizeMessage = () => {
           message.error('File size exceeds the limit of 10MB');
          }
    

     useEffect(() => {
     api.get(`${API_BASE_URL}challenges/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setFormInputs({
          title: response.data?.challengeTitle,
          subject: response.data?.subject,
          grade: response.data?.grade,
          challengeTheme: response.data?.requirement?.theme,
          designSubmission: response.data?.requirement?.designSubmission,
          nutshell: response.data?.requirement?.nutshell,
          mission: response.data?.requirement?.mission,
          judgingCriteria: response.data?.requirement?.judgingCriteria,
          termsConditions: response.data?.requirement?.termsConditions,
          videoUrl: response.data?.videoUrl,
    });
    setImg(response.data?.img);
    setCover(response.data?.coverImg);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);


        const isFormValid = formInputs.title.trim() !== '' && formInputs.subject.trim() !== '' && formInputs.grade.trim() !== '' && formInputs.videoUrl.trim() !== '' ;
       
        const handleImgChange = async (img) => {
          setCardLoading(true);
          if (img.size > MAX_SIZE) {
          sizeMessage();
          return;
          }
          const formData = new FormData();
          formData.append('img', img);
          console.log('Uploaded file:', img);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCardLoading(false);
                                  successPhoto();
                                  setImg(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

      const handleCoverChange = async (cover) => {
          setCoverLoading(true);
          if (cover.size > MAX_SIZE) {
          sizeMessage();
          return;
          }
        const formData = new FormData();
          formData.append('img', cover);
          console.log('Uploaded file:', cover);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCoverLoading(false);
                                  successPhoto();
                                    setCover(response.data);
                                  // setData(response.data)
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });

        };


    const handleSubmit = (event) => {
    event.preventDefault();
      submitForm();
    }

        const submitForm = async () => {
        await api.patch(`${API_BASE_URL}challenges/${id}`,{
          challengeTitle: formInputs.title,
          subject: formInputs.subject,
          grade: formInputs.grade,
          theme: formInputs.challengeTheme,
          designSubmission: formInputs.designSubmission,
          nutshell: formInputs.nutshell,
          mission: formInputs.mission,
          judgingCriteria: formInputs.judgingCriteria,
          termsConditions: formInputs.termsConditions,
          img: img? img.id : null,
          cover: cover? cover.id : null,
          videoUrl: formInputs.videoUrl,
       })
                    .then(function (response) {
                      console.log("Challenge created: ", response.data)
                          success();
                    }).catch(error => {
                      console.log("handlesubmit error for blog get ", error.response?.data?.message)
                    errormassage(error.response?.data?.message || 'Something went wrong');
                     
                    });
            
          }
    

  return (
   <form className="addChallenge" onSubmit={handleSubmit}>
    <h2>Edit Challenge</h2>
    <div className="addChallengeFlex">
      <div className="addChallengeLR">
          <div className="addCHInpts">
            {/* <span>Challenge title</span> */}
            <label for="challengeTitle">Challenge title</label>
            <input type="text" className="inputWidth" id="challengeTitle" value={formInputs.title} placeholder="Enter challenge title" 
            onChange={(e) =>setFormInputs({...formInputs, title: e.target.value})}/>
          </div>
            <div className="addCHInpts">
            <label for="gradeLevel">Grade level</label>
            <input type="text" className="inputWidth" id="gradeLevel" value={formInputs.grade} placeholder="Enter grade level"
             onChange={(e) =>setFormInputs({...formInputs, grade: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="challengeTheme">Challenge theme</label>
            <textarea type="text" className="inputWidth" id="challengeTheme" value={formInputs.challengeTheme} placeholder="Enter Challenge theme"
             onChange={(e) =>setFormInputs({...formInputs, challengeTheme: e.target.value})}/>
           </div>
         <div className="addCHInpts">
            <label for="designGuidelines">Design & Submission guidelines</label>
            <textarea type="text" className="inputWidth" id="designGuidelines" value={formInputs.designSubmission} placeholder="Enter Design & Submission guidelines"
             onChange={(e) =>setFormInputs({...formInputs, designSubmission: e.target.value})}/>
           </div>
          <div className="addCHInpts">
            <label for="nutshell">Nutshell</label>
            <textarea type="text" className="inputWidth" id="nutshell" value={formInputs.nutshell} placeholder="Enter Nutshell"
             onChange={(e) =>setFormInputs({...formInputs, nutshell: e.target.value})}/>
           </div>
       <h4 className="trAttachment"> Card Image </h4>
        <div className=" mrAtt">
        <FileUploader handleChange={handleImgChange} name="file" types={fileTypes} />
         <Loader loading={cardLoading} />
           {img && !cardLoading ? <img src={`${FILES_URL}${img.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>
        </div>
          <div className="addChallengeLR">
          <div className="addCHInpts">
            <label for="subject">Subject</label>
            <input type="text" className="inputWidth" id="subject" value={formInputs.subject} placeholder="Enter subject"
             onChange={(e) =>setFormInputs({...formInputs, subject: e.target.value})}/>
          </div>
     <div className="addCHInpts">
            <label for="mission">Mission</label>
            <textarea type="text" className="inputWidth" id="mission" value={formInputs.mission} placeholder="Enter Mission" 
            onChange={(e) =>setFormInputs({...formInputs, mission: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="judgingCriteria">Judging criteria</label>
            <textarea type="text" className="inputWidth" id="judgingCriteria" value={formInputs.judgingCriteria} placeholder="Enter Judging Criteria" 
            onChange={(e) =>setFormInputs({...formInputs, judgingCriteria: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Terms & Conditions</label>
            <textarea type="text" className="inputWidth" id="termsConditions" value={formInputs.termsConditions} placeholder="Enter Terms & Conditions" 
            onChange={(e) =>setFormInputs({...formInputs, termsConditions: e.target.value})}/>
          </div>
    <div className="addCHInpts">
            <label for="termsConditions">Video Url</label>
            <textarea type="text" className="inputWidth" id="videoUrl" value={formInputs.videoUrl} placeholder="Enter Video Url" 
            onChange={(e) =>setFormInputs({...formInputs, videoUrl: e.target.value})}/>
          </div>

       <h4 className="trAttachment"> Cover Image </h4>
        <div className=" mrAtt">
        <FileUploader handleChange={handleCoverChange} name="file" types={fileTypes} />
        <Loader loading={coverLoading} />
      {cover && !coverLoading ?<img src={`${FILES_URL}${cover.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
        </div>

    </div>   

        </div>
        <div style={{textAlign:"center"}}>
        <button type="submit" disabled={!isFormValid} className="add-Challenge">Publish</button>
        </div>
       </form> 
  );
};

export default EditChallenge;
